// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".56b393d05e05cb692ddec8609d2b055dff9b46d3.chunk.bundle.js";
};